import { render, staticRenderFns } from "./replaceManager.vue?vue&type=template&id=6cb10acc&scoped=true"
import script from "./replaceManager.vue?vue&type=script&lang=js"
export * from "./replaceManager.vue?vue&type=script&lang=js"
import style0 from "./replaceManager.vue?vue&type=style&index=0&id=6cb10acc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb10acc",
  null
  
)

export default component.exports